import { Component, OnInit } from '@angular/core';
import { ModalitesService } from 'src/app/core/modalites.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { IntegerInputKeypadComponent } from './integer-input-keypad.component';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

/**
 * Composant pour gérer une liste de modalité affectée à une variable.
 * Optimisé pour les enquêtes décisions. On utilise pas HTML5 ici.
 */
@Component({
    selector: 'bis-integer-sans-consultation-input-keypad',
    templateUrl: './integer-sans-consultation-input-keypad.component.html',
    styleUrls: ['../../input/input.component.css']
})
export class IntegerSansConsultationInputKeypadComponent extends IntegerInputKeypadComponent implements OnInit {

    constructor(
        protected modalitesService: ModalitesService,
        protected formulaireService: FormulaireService,
        protected libelleService: LibellesService,
        protected filtreService: FiltreService,
        public modeRenduService: ModeRenduService
    ) {
        super(formulaireService, libelleService, filtreService, modeRenduService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public onKeyUp(event): void {
        if (event.keyCode === 13) {
            document.getElementById('buttonAfficher').click();     
        }
    }
}
